import { render } from "./Vervaardiging.vue?vue&type=template&id=73e2c934&scoped=true&ts=true"
import script from "./Vervaardiging.vue?vue&type=script&lang=ts"
export * from "./Vervaardiging.vue?vue&type=script&lang=ts"

import "./Vervaardiging.vue?vue&type=style&index=0&id=73e2c934&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e2c934"]])

export default __exports__